// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-logo {
	width: 90px;
	height: 90px;
	border-radius: 50%;
}

.login-form {
	background: var(--white);
	padding: 30px;
	margin-top: 20px;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	width: 450px;
	height: 450px;
}

.username-label,
.password-label {
	margin-bottom: 5px;
	font-size: 20px;
}

.password-wrapper,
.username-wrapper {
	display: flex;
	flex-direction: row-reverse;
	justify-content: center;
	align-items: center;
	position: relative;
}

.username-input,
.password-input {
	padding-right: 50px;
	padding-left: 0;
}

.toggle-password,
.username-icon {
	background: none;
	border: none;
	cursor: pointer;
	outline: none;
	position: absolute;
	top: 40%;
	right: 10px;
	transform: translateY(-50%);
	color: #888;
}

.login-button {
	width: 100%;
	height: 50px;
	background-color: var(--primary-color);
	color: var(--white);
	border: none;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s;
	font-size: 20px;
	margin-top: 30px;
}

.login-button:hover {
	background-color: var(--primary-hover);
}

.login-link {
	font-size: 18px;
	padding: 5px 0;
}

.login-link-btn {
	background: none;
	border: 1.5px solid #e74c3c;
	border-radius: 6px;
	cursor: pointer;
	font-size: 20px;
	padding: 8px 18px;
	color: var(--primary-color);
	align-self: center;
}

.login-link-btn:hover {
	color: black;
}

@media (max-width: 480px) {
	.login-form {
		width: 400px;
		height: 450px;
	}

	.username-lable,
	.password-lable {
		font-size: 18px;
	}

	.login-link {
		font-size: 1rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,yCAAyC;CACzC,YAAY;CACZ,aAAa;AACd;;AAEA;;CAEC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;CAEC,aAAa;CACb,2BAA2B;CAC3B,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,eAAe;CACf,aAAa;CACb,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sCAAsC;CACtC,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iCAAiC;CACjC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;;EAEC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD","sourcesContent":[".login-logo {\n\twidth: 90px;\n\theight: 90px;\n\tborder-radius: 50%;\n}\n\n.login-form {\n\tbackground: var(--white);\n\tpadding: 30px;\n\tmargin-top: 20px;\n\tborder-radius: 8px;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\twidth: 450px;\n\theight: 450px;\n}\n\n.username-label,\n.password-label {\n\tmargin-bottom: 5px;\n\tfont-size: 20px;\n}\n\n.password-wrapper,\n.username-wrapper {\n\tdisplay: flex;\n\tflex-direction: row-reverse;\n\tjustify-content: center;\n\talign-items: center;\n\tposition: relative;\n}\n\n.username-input,\n.password-input {\n\tpadding-right: 50px;\n\tpadding-left: 0;\n}\n\n.toggle-password,\n.username-icon {\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\toutline: none;\n\tposition: absolute;\n\ttop: 40%;\n\tright: 10px;\n\ttransform: translateY(-50%);\n\tcolor: #888;\n}\n\n.login-button {\n\twidth: 100%;\n\theight: 50px;\n\tbackground-color: var(--primary-color);\n\tcolor: var(--white);\n\tborder: none;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s;\n\tfont-size: 20px;\n\tmargin-top: 30px;\n}\n\n.login-button:hover {\n\tbackground-color: var(--primary-hover);\n}\n\n.login-link {\n\tfont-size: 18px;\n\tpadding: 5px 0;\n}\n\n.login-link-btn {\n\tbackground: none;\n\tborder: 1.5px solid #e74c3c;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tfont-size: 20px;\n\tpadding: 8px 18px;\n\tcolor: var(--primary-color);\n\talign-self: center;\n}\n\n.login-link-btn:hover {\n\tcolor: black;\n}\n\n@media (max-width: 480px) {\n\t.login-form {\n\t\twidth: 400px;\n\t\theight: 450px;\n\t}\n\n\t.username-lable,\n\t.password-lable {\n\t\tfont-size: 18px;\n\t}\n\n\t.login-link {\n\t\tfont-size: 1rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
